export const mobile = 800;
export const mobileMinWidth = mobile + 1 + "px";
export const mobileMaxWidth = mobile + "px";
